import BigNumber from "bignumber.js";
import route_map from "@/config/route_map";

// 移动端响应式断点（与设计稿一致：≤800px 视为 H5）
export const mobile = "@media screen and (max-width:800px)";

export const formatPrice = (amount, precision) => {
  const amountBn = new BigNumber(amount || 0);
  return precision === undefined
    ? amountBn.toFormat()
    : amountBn.toFormat(precision);
};

export const formatePercent = (value, precision = 2) => {
  const valueBn = new BigNumber(value || 0);
  return `${valueBn.toFixed(precision)}%`;
};

export const formatAmount = (amount, precision = 2) => {
  const amountBn = new BigNumber(amount || 0);
  const absBn = amountBn.abs();
  if (absBn.gte(1e6)) {
    return `${amountBn.div(1e6).toFixed(precision)}M`;
  }
  if (absBn.gte(1e3)) {
    return `${amountBn.div(1e3).toFixed(precision)}K`;
  }
  return amountBn.toFixed(precision);
};

/**
 * www 同域整页跳转。
 * 传入子路径（接口/页面后半段），自动拼到 route_map.default（含域名 + 语言前缀）后面。
 * 例：linkTo(`/strategy-bot/trader-order/${uid}`)
 * @param {string} path 以 "/" 开头的子路径
 * @param {string} [target] "_self"(默认) | "_blank"
 */
export const linkTo = (path = "", target = "_self") => {
  const url = `${route_map.default}${path}`;
  if (target === "_blank") {
    window.open(url, "_blank");
  } else {
    window.location.href = url;
  }
};

/**
 * 跳转到合约交易页，可选指定交易对
 * @param {string} [symbol] 交易对，如 "BTCUSDT"、"ETH_USDT"（自动去除下划线）
 * @param {string} [target] "_self" | "_blank"
 */
export const goToFuturesTrade = (symbol = "", target = "_self") => {
  const pair = symbol.replace(/[_/]/g, "").toUpperCase();
  const url = pair ? `${route_map.futures}/${pair}` : route_map.futures;
  if (target === "_blank") {
    window.open(url, "_blank");
  } else {
    window.location.href = url;
  }
};
